import { render, staticRenderFns } from "./groundingModal.vue?vue&type=template&id=4a3b02f7&scoped=true"
import script from "./groundingModal.vue?vue&type=script&lang=js"
export * from "./groundingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b02f7",
  null
  
)

export default component.exports